import { css as _css } from "@emotion/core";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import PropTypes from 'prop-types';
import { withMedia } from 'react-media-query-hoc';
import { Heading } from '@domain-group/fe-co-allhomes-design-system';
import KeyDetailsItem from './items/key-details-item';
import * as styles from './allhomes-key-details.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var AllhomesKeyDetailsBase = props => {
  var hasApprox = props.otherDetails.some(each => each.approximate);
  return ___EmotionJSX("div", {
    css: /*#__PURE__*/_css([styles.container, props.className])
  }, ___EmotionJSX(Heading, {
    title: "Key details"
  }), ___EmotionJSX("div", {
    css: styles.contentsWithColumns
  }, props.keyDetails.map(each => ___EmotionJSX(KeyDetailsItem, _extends({
    className: styles.keyDetailItem,
    key: each.label
  }, each)))), ___EmotionJSX("h3", {
    css: styles.subheading
  }, "Other Details"), ___EmotionJSX("div", {
    css: styles.contents
  }, props.otherDetails.filter(each => each.value).map(each => ___EmotionJSX(KeyDetailsItem, _extends({
    key: each.label
  }, each))), hasApprox && ___EmotionJSX("div", {
    css: styles.footnote
  }, ___EmotionJSX("sup", null, "*"), "These are approximate values based on available information.")));
};
AllhomesKeyDetailsBase.propTypes = {
  otherDetails: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    note: PropTypes.string,
    approximate: PropTypes.bool
  })).isRequired,
  keyDetails: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    link: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.string,
    note: PropTypes.string,
    approximate: PropTypes.bool
  })).isRequired,
  threshold: PropTypes.number,
  media: PropTypes.shape({
    desktop: PropTypes.bool
  }),
  title: PropTypes.string,
  className: PropTypes.string
};
AllhomesKeyDetailsBase.defaultProps = {
  media: {},
  threshold: 4,
  title: 'Key Details',
  className: undefined
};
export default withMedia(AllhomesKeyDetailsBase);